import { THEME_COLORS, THEME_FONTS } from '../helpers/constants/themes'
const LINE_HEIGHT_FACTOR = '1.35'
const importAll = (data) => {
  const files = []
  data.keys().forEach((item) => {
    files[item.replace('./', '')] = data(item)
  })
  return files
}

// Font sizes
// ============================================================
export const FONT_SIZE = {
  SSMMN: `${5}px`,
  MMN: `${10}px`,
  MN: `${12}px`,
  TN: `${14}px`,
  XXS: `${16}px`,
  XS: `${18}px`,
  SM: `${20}px`,
  MD: `${24}px`,
  LMD: `${26}px`,
  LG: `${28}px`,
  LG2: `${30}px`,
  XL: `${32}px`,
  XXL: `${34}px`,
  XXXL: `${40}px`,
  XXXL2: `${48}px`,
  XXXXL: `${64}px`
}

// Colors
// ============================================================
export const COLOR = {
  BLACK: '#000000',
  BLACK_1: '#0E0E0F',
  BLACK_2: '#2C2C2E',
  BLACK_3: '#5F5F66',
  BLACK_4: '#010101',
  BLACK_5: '#363636',
  BLACK_6: '#0A0A0A',
  WHITE: '#FFFFFF',
  WHITE_2: '#E6E6E6',
  PEARL: '#FAF5F2',
  PEARL_2: '#F2EDE8',
  RED_1: '#FFB7C1',
  RED_2: '#FF4B64',
  RED_3: '#E4505E',
  GREEN_1: '#23CF5F',
  GREEN_2: '#54a678',
  BLUE_1: '#0079AD',
  BLUE_2: '#98C8DE',
  BLUE_3: '#BFC4DB',
  BLUE_4: '#337AB7',
  BLUE_5: 'hsl(198,60%,60%)',
  BLUE_6: '#0079AD66',
  BLUE_7: '#294a80',

  YELLOW_1: '#FDB900',
  GRAY_1: '#F1F2F2',
  GRAY_2: '#F6F6F6',
  GRAY_3: '#9E9E9E',
  GRAY_4: '#FDFDFE',
  GRAY_5: '#E5E5E5', // shadow
  GRAY_6: '#E6E6F6',
  GRAY_7: '#808082',
  GRAY_8: '#BFBFC0',
  GRAY_9: '#808080',
  GRAY_10: '#666666',
  GRAY_11: '#636466',
  GRAY_12: '#9E9E9F',
  GRAY_13: '#f5f5f5',
  GRAY_14: '#8F8782',
  GRAY_15: '#AAAAAA',
  GRAY_16: '#0E0E0F66',
  GRAY_17: '#BCB7B4',
  GRAY_18: '#EEEEEE',
  GRAY_19: '#CCCCCC',
  GRAY_20: '#999999',
  GRAY_21: '#EFEFEF',
  GRAY_22: '#D2CFCD',
  GRAY_23: '#676767',
  GRAY_24: '#C8C8C8',
  Sky_1: '#98C8DE',
  SUNDAY_DIS: '#FF8080',
  SUNDAY: '#FF2A2A',
  SATDAY_DIS: '#AA87DE',
  SATDAY: '#9955FF',
  GOLD_1: '#CFB58F',
  GOLD_2: '#CFB590',
  GOLD_3: '#DFD0BA',
  VIOLET: '#785278',
  ORANGE: '#db6652',
  BROWN_1: '#5D4031',
  GRAY_25: '#888888',
  GRAY_26: '#ADADAD',
  GRAY_27: '#737373',

  TOAST_BOOKING: '#6C6860',
  TOAST_INVITED: '#878278',
  TOAST_EXTEND: '#0C4A6E',
  TOAST_ACCEPTED: '#14532D',
  TOAST_DECLINED: '#7C2D12',

  LOADING: 'rgba(0, 0, 0, 0.5)',
  BACKDROP: 'rgba(23, 23, 23, 0.60)',
  TRANSPARENCY: 'rgba(0, 0, 0, 0)',
}

export function getFontContrastColor (color = '') {
  const theme = Object.values(THEME_COLORS).find(({ MAIN }) => MAIN === String(color).toUpperCase())
  return theme && theme.FONT_COLOR === THEME_FONTS.WHITE_FONTS ? COLOR.WHITE : COLOR.BLACK_1
}

export const NATIVE_BASE_COLORS = {
  PRIMARY: {
    50: '#FFE9D1',
    100: '#EACAB2',
    200: '#CFB58F',
    300: '#B28A6A',
    400: '#9C714E',
    500: '#865933',
  },
  TEXT: {
    50: '#FAFAFA',
    100: '#F5F5F5',
    200: '#E5E5E5',
    300: '#D4D4D4',
    400: '#A3A3A3',
    500: '#737373',
    700: '#404040',
    800: '#262626',
    900: '#171717',
  },
  MUTED: {
    200: '#E5E5E5',
    300: '#D4D4D4',
    600: '#525252',
    700: '#404040',
    800: '#262626',
    900: '#171717',
  },
  ERROR: {
    400: '#F87171',
    500: '#EF4444',   
  },
  SUCCESS: {
    100: '#DCFCE7',
    700: '#15803D',
  },
  INFO: {
    100: '#E0F2FE',
    700: '#0369A1',
  },
  WARNING: {
    100: '#FFEDD5',
    700: '#C2410C',
  },
}

//
// Line heights
// ============================================================
export const LINE_HEIGHTS = {
  MN: `calc(${LINE_HEIGHT_FACTOR} * ${FONT_SIZE.MN})`, // 16.2px
  SM: `calc(${LINE_HEIGHT_FACTOR} * ${FONT_SIZE.SM})`, // 16.2px
  MD: `calc(${LINE_HEIGHT_FACTOR} * ${FONT_SIZE.MD})`, // 18.9px
  LG: `calc(${LINE_HEIGHT_FACTOR} * ${FONT_SIZE.LG})`, // 21.6px
  XL: `calc(${LINE_HEIGHT_FACTOR} * ${FONT_SIZE.XL})`, // 24.3px
  XXL: `calc(${LINE_HEIGHT_FACTOR} * ${FONT_SIZE.XXL})` // 24.3px
}

// Zindexs
// ============================================================
export const Z_INDEXS = {
  LV_0: '0',
  LV_1: '1',
  LV_2: '2',
  LV_3: '3',
  LV_4: '4',
  LV_5: '5',
  LV_6: '6',
  LV_7: '7',
  LV_8: '8',
  LV_9: '9',
  LV_10: '10',
  LV_11: '11',
  LV_MAX: '1000'
}

// Button sizes
// ============================================================
export const BUTTON_SIZE = {

  LINE_HEIGHTS: {
    XS: '24px',
    SM: '36px',
    MD: '46px'
  }
}

// Component width/height/others
// ============================================================
export const FIELD = {
  // Width
  WIDTHS: {
    XS: '200px',
    SM: '250px',
    MD: '350px',
    LG: '450px'
  },
  // Height
  HEIGHT: {
    XS: '20px',
    SM: '26px',
    MD: '30px',
    LG: '40px'
  },
  // Border radius
  BORDER_RADIUS: '6px',
  // Type
  TYPES: {
    TEXT: {
      HEIGHT: '30px'
    },
    TEXT_AREA: {
      HEIGHT: '90px'
    }
  }
}

export const CHECKBOX = {
  WIDTH: '16px',
  HEIGHT: '16px',
  BORDER_RADIUS: '3px'
}

// FIX
export const IMG = importAll(require.context('./images', false, /\.(png|jpe?g|gif|svg)$/))
// export const FIX_WIDTH = 1366
// export const FIX_HEIGHT = 768
export const WIDTH_SIDEBAR = 240
export const HEIGHT_TOP_BAR = 45

export const SIDE_BAR = {
  WIDTH_SIZE: '260px'
}

export const TOPBAR_SIZE = {
  LV_1: '64px',
  LV_2: '76px',
}
